var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"d-flex justify-center"},[_c('v-col',[_c('v-alert',{attrs:{"text":"","prominent":"","type":"error","icon":"mdi-cloud-alert"}},[_vm._v(" There has been an error ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }